import AbstractFormulaNode from "./AbstractFormulaNode.js";
import AccountFormulaNode from "./AccountFormulaNode.js";
import AdditionFormulaNode from "./AdditionFormulaNode.js";
import AverageDataFormulaNode from "./AverageDataFormulaNode.js";
import BalanceFormulaNode from "./BalanceFormulaNode.js";
import ChangeDataFormulaNode from "./ChangeDataFormulaNode.js";
import ChangeFormulaNode from "./ChangeFormulaNode.js";
import ClosingBalanceFormulaNode from "./ClosingBalanceFormulaNode.js";
import ComponentFormulaNode from "./ComponentFormulaNode.js";
import ConstantFormulaNode from "./ConstantFormulaNode.js";
import DataFormulaNode from "./DataFormulaNode.js";
import DimensionFormulaNode from "./DimensionFormulaNode.js";
import DivisionFormulaNode from "./DivisionFormulaNode.js";
import KeyFigureFormulaNode from "./KeyFigureFormulaNode.js";
import ModelFactory from "../../ModelFactory.js";
import MultiplicationFormulaNode from "./MultiplicationFormulaNode.js";
import NaFormulaNode from "./NaFormulaNode.js";
import NegatedFormulaNode from "./NegatedFormulaNode.js";
import NumberOfDaysInFiscalYearNode from "./NumberOfDaysInFiscalYearNode.js";
import NumberOfDaysInPeriodNode from "./NumberOfDaysInPeriodNode.js";
import OpeningBalanceFormulaNode from "./OpeningBalanceFormulaNode.js";
import OrFormulaNode from "./OrFormulaNode.js";
import PeriodChangeFormulaNode from "./PeriodChangeFormulaNode.js";
import PeriodRollingFormulaNode from "./PeriodRollingFormulaNode.js";
import PeriodShiftFormulaNode from "./PeriodShiftFormulaNode.js";
import PreviousPeriodFormulaNode from "./PreviousPeriodFormulaNode.js";
import PreviousYearFormulaNode from "./PreviousYearFormulaNode.js";
import ReportReferenceFormulaNode from "../../reports/templates/ReportReferenceFormulaNode.js";
import SubtractionFormulaNode from "./SubtractionFormulaNode.js";
import SumFormulaNode from "./SumFormulaNode.js";
import YearOpeningBalanceFormulaNode from "./YearOpeningBalanceFormulaNode.js";

/**
 * Create instances `AbstractFormulaNode`'s subclasses.
 */
class FormulaFactory extends ModelFactory {
	allClasses() {
		return [
			AbstractFormulaNode,
			AccountFormulaNode,
			AdditionFormulaNode,
			AverageDataFormulaNode,
			BalanceFormulaNode,
			ChangeDataFormulaNode,
			ChangeFormulaNode,
			ClosingBalanceFormulaNode,
			ComponentFormulaNode,
			ConstantFormulaNode,
			DataFormulaNode,
			DimensionFormulaNode,
			DivisionFormulaNode,
			KeyFigureFormulaNode,
			MultiplicationFormulaNode,
			NaFormulaNode,
			NegatedFormulaNode,
			NumberOfDaysInFiscalYearNode,
			NumberOfDaysInPeriodNode,
			OpeningBalanceFormulaNode,
			OrFormulaNode,
			PeriodChangeFormulaNode,
			PeriodRollingFormulaNode,
			PeriodShiftFormulaNode,
			PreviousPeriodFormulaNode,
			PreviousYearFormulaNode,
			ReportReferenceFormulaNode,
			SubtractionFormulaNode,
			SumFormulaNode,
			YearOpeningBalanceFormulaNode,
		];
	}

	isKeyFigureDataNodeType(nodeType) {
		return this._findClassFromType(nodeType).isKeyFigureDataNode();
	}
}

const formulaFactory = new FormulaFactory();

export default formulaFactory;
